import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {QuestionConfigurations} from "./question.configurations";
import {KlaHttpService} from "../services/kla.http.service";
import { Image } from '../services/kla.data.models';
import { CommonModule } from '@angular/common';
import { ImageObjectComponent } from '../image-object/image-object.component';
import { ButtonComponent } from '../button/button.component';
import { BadgesComponent } from '../badges/badges.component';
import { SocialMediaButtonsComponent } from '../social-media-buttons/social-media-buttons.component';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, ImageObjectComponent, ButtonComponent, BadgesComponent, SocialMediaButtonsComponent, StripSpecialCharsPipe, DynamicContentComponent ]
})
export class QuestionComponent implements OnInit {

  @Input()
  public config: QuestionConfigurations;

  @Input()
  public imageObject: Image;

  @Output()
  public click: EventEmitter<Event> = new EventEmitter<Event>();

  get isLinkVisible() {
    return this.config?.isLinkVisible;
  }

  ngOnInit() {
    if (!this.config) {
      this.config = <QuestionConfigurations> {};
    }
    if(this.imageObject) {
    this.imageObject.width = 900;
      this.imageObject = {
        id: this.imageObject.id,
        width: +this.imageObject.width,
        height: +this.imageObject.height,
        cropConfig: this.imageObject.crop_config,
        alt: this.imageObject.alt,
        caption: this.imageObject.caption
      };
    }
  }

  onClick(event: Event, link?: string) {
    this.click.emit(event);
    if (link) {
      window.open(link, '_blank');
    }
  }
}
